import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import WhatsAppFloat from './WhatsAppFloat';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    const initial = document.getElementById('__initial_canonical__');
    if (initial) initial.remove();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
      <WhatsAppFloat 
        phoneNumber="+49 179 7473491"
        message="Hallo! Ich interessiere mich für Ihre Angebote von Easy Vertrag."
        showAfterSeconds={5}
      />
    </div>
  );
};

export default Layout;